import api from "../../../api";
import {typedQuery} from "../../typing";

export const reportTemplates = typedQuery(["tprm", "reportTemplates"], async () => {
  return await api.tprm.reportTemplates.list();
});

export const reportTemplatePromptRegistry = typedQuery(["tprm", "reportTemplatePromptRegistry"], async () => {
  return await api.tprm.reportTemplates.promptRegistry();
});
